import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { CreateExtractRefresh } from '../AppActionTypes';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ContentActionNotification } from '../../../commonInfra/contentActions/ContentActionNotification';
import { IError } from '../../../httpClient/serverApi/types/IError';
import { Messages } from '../../../codegen/Localize';
import { Recurrence } from '@tableau/self-service-schedules';
import { SetExtractTasksSelfServiceScheduleRequest } from '../../../ts/ServerApi/requests/SetExtractTasksSelfServiceScheduleRequest';
import { SelfServiceSchedule } from '../../../ts/ServerApi/types/SelfServiceSchedule';
import { RefreshTaskType } from '../../../ts/ServerApi/requests/CreateSelfServiceScheduleExtractTasksRequest';
import WebHttpClient from '../../../httpClient/WebHttpClient';
import { CreateExtractTasksMode } from '~src/extract/actions/CreateExtractTaskAction';

export interface CreateExtractRefreshAction extends Action {
  selectedContent: IContentInfo[];
  mode: CreateExtractTasksMode;
}

export namespace CreateExtractRefreshAction {
  export function sendCreateExtractRequest(recurrence: Recurrence, taskType: RefreshTaskType, scheduleName: string, ids: number[]): Promise<IResult> {
    const request = new SetExtractTasksSelfServiceScheduleRequest({
      schedule: SelfServiceSchedule.fromRecurrence(recurrence, 'Extract'),
      type: taskType,
      scheduleName: scheduleName.substring(0, 255),
      ids,
    });
    return new Promise<IResult>((resolve, reject) => {
      WebHttpClient.sendRequest(request).then(result => {
        CreateExtractRefreshAction.notifyResult(result, false);
        resolve(result);
      }).catch(err => {
        CreateExtractRefreshAction.notifyResult();
        reject(err);
      });
    });
  }

  function errorCodeToMessage(error: IError): string {
    switch (error.code) {
      default:
        return Messages.refreshSelfServiceScheduleUnexpectedError({ ERROR_CODE: String(error.code) });
    }
  }

  export function notifyResult(result?: IResult, isNew?: boolean) {
    if (result && result.errors && result.errors.length) {
      const errorMessage = errorCodeToMessage(result.errors[0]);
      ContentActionNotification.displayFailureToast(errorMessage);
    } else {
      const toastContent = isNew
        ? Messages.refreshSelfServiceScheduleCreateSuccess()
        : Messages.refreshSelfServiceScheduleChangeSuccess();
      ContentActionNotification.displaySuccessToast(toastContent);
    }
  }
}

export function createExtractRefresh(
  selectedContent: IContentInfo[],
  mode: CreateExtractTasksMode
): CreateExtractRefreshAction {
  return {
    type: CreateExtractRefresh,
    selectedContent,
    mode,
  };
}
